import { useMutation, useQueryClient } from '@tanstack/react-query';
import automateAxios from '../../../utils/automateAxios';
import { MutationKeys } from '../../mutation/mutation.enum';
import { QueryKeys } from '../../querys/querys.enum';
import { AutomationPrompt, UpdatePromptPayload } from '../../../models/Interface/Automation.interface';

interface UpdateParams {
  slug: string;
  payload: UpdatePromptPayload;
}

const updatePrompt = async ({ slug, payload }: UpdateParams): Promise<AutomationPrompt> => {
  const response = await automateAxios.patch<AutomationPrompt>(
    `/prompts/${encodeURIComponent(slug)}`,
    payload
  );
  return response.data;
};

const useUpdateAutomationPrompt = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MutationKeys.UPDATE_AUTOMATION_PROMPT],
    mutationFn: updatePrompt,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.AUTOMATION_PROMPTS] });
    },
  });
};

export default useUpdateAutomationPrompt;
